import { TransactCampusCardHostSystem } from './transact_campus_card_host_system.js';

export function name(hostSystem: TransactCampusCardHostSystem): string {
  switch (hostSystem) {
    case TransactCampusCardHostSystem.TSE:
      return 'TSE';
    case TransactCampusCardHostSystem.IDX:
      return 'IDX';
  }
}
